import fullRoutes from '@/pages/route-config';
import { FETCH_GLOBAL_INFO } from './user-info';
import {
  addIndexRoute,
  addNotFoundRoute,
  installDynamicRoutes,
  filterDisabledRoutes,
  flatMenus,
  flatMenusByCode,
  updateTargetMenu,
  mergeDataTo,
} from './menus.utils';
import { setAllowedMenus, getAllowedMenus, getAllowedMenusByCode, setAllowedMenusByCode } from './allowed-menus';
import { pushDuccRoutesIn } from '@/pages/route-config-inducc';

/**
 * 完整路由的计算依赖duccRoutes，所以在设计路由变更的所有action中需要注入存在sotre中的duccRoutes
 */
export const menuMiddleware = (store) => (next) => (action) => {
  const { type, payload } = action;

  if (type === DYNAMIC_PUSH_ROUTE || type === UPDATE_SUBMENUS || type === REPLACE_MENU) {
    const { duccRoutes } = store.getState(); // 获取全局 state
    payload._duccRoutes = payload._duccRoutes || duccRoutes;
    return next(action);
  } else {
    return next(action);
  }
};

// ActionTypes
const DYNAMIC_PUSH_ROUTE = 'DYNAMIC_PUSH_ROUTE';
const UPDATE_SUBMENUS = 'UPDATE_SUBMENUS';
const REPLACE_MENU = 'REPLACE_MENU';

// actionCreater
export function registerRoute(parentId, menus) {
  return {
    type: DYNAMIC_PUSH_ROUTE,
    payload: {
      parentId,
      menus,
    },
  };
}

export function updaterRoute(parentId, menus, allowedMenus) {
  return {
    type: UPDATE_SUBMENUS,
    payload: {
      parentId,
      menus,
      allowedMenus,
    },
  };
}

export function replaceRoute(menuId, menuItem) {
  return {
    type: REPLACE_MENU,
    payload: {
      menuId,
      menuItem,
    },
  };
}

// 有两层意思：
// 1. 后端菜单权限已经返回
// 2. 被允许菜单
// 将菜单分层级展开
export default (state = [], action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_GLOBAL_INFO:
      setAllowedMenus(flatMenus(payload.menus));
      setAllowedMenusByCode(flatMenusByCode(payload.menus));
      return addIndexRoute(
        addNotFoundRoute(
          mergeDataTo(
            filterDisabledRoutes(state, getAllowedMenus(), getAllowedMenusByCode()),
            filterDisabledRoutes(
              pushDuccRoutesIn(fullRoutes, 0, payload._duccRoutes),
              getAllowedMenus(),
              getAllowedMenusByCode()
            )
          )
        )
      );
    case DYNAMIC_PUSH_ROUTE:
      // 动态路由这里只会根据顶层路由分割
      return installDynamicRoutes(
        state,
        {
          ...payload,
          menus: pushDuccRoutesIn(payload.menus, payload.parentId, payload._duccRoutes),
        },
        fullRoutes,
        getAllowedMenus(),
        getAllowedMenusByCode()
      );
    case UPDATE_SUBMENUS:
      return updateTargetMenu(
        payload.parentId,
        pushDuccRoutesIn(payload.menus, payload.parentId, payload._duccRoutes),
        state,
        Object.assign({}, flatMenus(payload.allowedMenus), getAllowedMenus()),
        Object.assign({}, flatMenusByCode(payload.allowedMenus), getAllowedMenusByCode())
      );
    case REPLACE_MENU: {
      // 目前只处理第一层
      const { menuId, menuItem } = payload;
      let replaceIndex = -1;

      if (menuId == null) {
        // 找到第一个没有menuid的menuitem
        replaceIndex = state.findIndex((item) => {
          return !item.menuId;
        });

        if (replaceIndex === -1) return [...state, menuItem];
        else {
          const newState = [...state];

          newState.splice(replaceIndex, 0, menuItem);

          return newState;
        }
      } else {
        // 携带menuid并且没有匹配到就什么也不做
        replaceIndex = state.findIndex((item) => {
          return item.menuId === menuId;
        });
        if (replaceIndex === -1) {
          console.warn(menuId + '在当前menuids中不存在');
          return state;
        }

        const newState = [...state];

        newState[replaceIndex] = menuItem;

        return newState;
      }
    }
    default:
      return state;
    // 默认给路由的话会引起当前页面二次渲染，
    // 感觉莫名其妙
    // return fullRoutes.slice(0, 2)
  }
};
